import { faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';

import AtlasMetadataClient from '@reuters-graphics/graphics-atlas-client';
import CountryLink from './../CountryLink';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Legend from './Legend';
import Logo from './Logo';
import React from 'react';
import RegionLink from './../RegionLink';
import Search from './Search';
import classnames from 'classnames';
import { getCountryOverallTrend } from 'Utils/calcOverallTrend';
import styles from './styles.module.scss';

const atlas = new AtlasMetadataClient();

const LinkBox = (props) => {
  const { globalStatistics } = props;

  const countriesWithStats = Object
    .keys(globalStatistics.latestTotals.cases)
    .filter(c => globalStatistics.latestTotals.cases[c] > 0);

  const regions = atlas.regions.map((region) => {
    const countries = region.countries
      .filter(c => countriesWithStats.includes(c.isoAlpha2));

    countries.sort((a, b) => {
      if (!globalStatistics.distributionRanks.cases[a.isoAlpha2]) return 1;
      if (!globalStatistics.distributionRanks.cases[b.isoAlpha2]) return -1;
      return globalStatistics.distributionRanks.cases[b.isoAlpha2] - globalStatistics.distributionRanks.cases[a.isoAlpha2];
    });

    const CountryLinks = countries.map(country => {
      const distributionRank = globalStatistics.distributionRanks.cases[country.isoAlpha2];
      const trend = getCountryOverallTrend(globalStatistics, country.isoAlpha2);
      return (
        <li
          className={classnames('country-link font-sans', {
            peak: distributionRank >= 0.9,
          })}
          key={country.isoAlpha2}
        >
          <CountryLink country={country.isoAlpha2} />
          {(trend.cases && trend.cases.increasing) && (
            <FontAwesomeIcon icon={faCaretUp} />
          )}
          {(trend.cases && trend.cases.decreasing) && (
            <FontAwesomeIcon icon={faCaretDown} />
          )}
        </li>
      );
    });
    return (
      <div className='region-links' key={region.slug}>
        <div className='section-spacer-internal' />
        <h3>
          <RegionLink region={region.slug} />
        </h3>
        <ul className='country-links'>
          {CountryLinks}
        </ul>
      </div>
    );
  });

  return (
    <div className={styles.component}>
      <div className='section-spacer' />
      <Logo />
      <Search
        countriesWithStats={countriesWithStats}
        globalStatistics={globalStatistics}
      />
      <div className='section-spacer-internal' />
      <Legend />
      {regions}
      <div className='section-spacer-internal' />
      <div className='section-spacer' />
    </div>
  );
};

export default React.memo(LinkBox);
